module.exports = __webpack_public_path__ + "img/Templates.4dcae52a.svg";